function Message(props) {
    return (
        props.message ? (
            <h6 className='text-end text-muted mt-3 mb-0'>
                <i className="fa-regular fa-bell fa-lg fa-fw fa-stack"></i>
                {props.message}
            </h6> 
        ) : null
    )
}

export default Message;